import { http } from '../../config/axios'

export default function getNotaFiscalPdf(id: string): Promise<Blob> {
  return http.get('/api/nota-fiscal/pdf/' + id, {
    responseType: 'blob'
  })
    .then((r) => r.data)
    .then((blobFile) => {
      return blobFile
    })
    .catch((error) => {
      console.error('Erro ao getNotaFiscalPdf')
      return new Blob()
    })
}
